var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-form" },
    [
      _vm.readOnly
        ? _c("div", { staticClass: "readonly-banner" }, [
            _c("strong", [
              _vm._v("This booking is " + _vm._s(_vm.bookingStatus) + ".")
            ]),
            _vm._v(" It can no longer be modified.\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "form-section" }, [
        _c("div", { staticClass: "section-heading" }, [
          _vm._v(_vm._s(_vm.$t("secBooking")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section-body" },
          [
            _c("StoreSelector", {
              attrs: { value: _vm.form.store_id },
              on: { change: _vm.onStoreChange, loaded: _vm.onStoresLoaded }
            }),
            _vm._v(" "),
            _c("DateRangePicker", {
              attrs: {
                "store-id": _vm.form.store_id,
                "drop-off-date": _vm.form.drop_off_date,
                "pick-up-date": _vm.form.pick_up_date,
                timezone: _vm.selectedStoreTimezone
              },
              on: { change: _vm.onDatesChange, valid: _vm.onDatesValid }
            }),
            _vm._v(" "),
            _c("LuggageSelector", {
              attrs: {
                "store-id": _vm.form.store_id,
                value: _vm.form.luggage,
                "fee-options": _vm.feeOptions,
                "drop-off-date": _vm.form.drop_off_date,
                "pick-up-date": _vm.form.pick_up_date
              },
              on: { change: _vm.onLuggageChange }
            }),
            _vm._v(" "),
            _c("FeeEstimate", { attrs: { estimate: _vm.estimate } }),
            _vm._v(" "),
            _c("div", { staticClass: "field email-field" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                staticClass: "field-input",
                class: { "has-error": _vm.emailError },
                attrs: { type: "email", placeholder: "jane@example.com" },
                domProps: { value: _vm.form.passenger.email },
                on: {
                  input: function($event) {
                    return _vm.onEmailChange($event.target.value)
                  },
                  blur: function($event) {
                    _vm.emailTouched = true
                  }
                }
              }),
              _vm._v(" "),
              _vm.emailError
                ? _c("p", { staticClass: "field-error" }, [
                    _vm._v(_vm._s(_vm.emailError))
                  ])
                : _vm._e()
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDetailSections,
              expression: "showDetailSections"
            }
          ],
          staticClass: "form-section"
        },
        [
          _c("div", { staticClass: "section-heading" }, [
            _vm._v(_vm._s(_vm.$t("passengerInfo")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-body" },
            [
              _c("PassengerInfo", {
                ref: "passengerInfo",
                attrs: {
                  value: _vm.form.passenger,
                  "hide-email": true,
                  "require-identity": _vm.submitIncludesDetails
                },
                on: { change: _vm.onPassengerChange }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDetailSections,
              expression: "showDetailSections"
            }
          ],
          staticClass: "form-section"
        },
        [
          _c("div", { staticClass: "section-heading" }, [
            _vm._v(_vm._s(_vm.$t("thirdParty")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-body" },
            [
              _c("ThirdPartyPickup", {
                attrs: {
                  value: _vm.form.thirdParty,
                  enabled: _vm.form.thirdPartyEnabled
                },
                on: { change: _vm.onThirdPartyChange }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDetailSections,
              expression: "showDetailSections"
            }
          ],
          staticClass: "form-section"
        },
        [
          _c("div", { staticClass: "section-heading" }, [
            _vm._v(_vm._s(_vm.$t("hazardous")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-body" },
            [
              _c("HazardousDeclaration", {
                ref: "hazardous",
                on: { valid: _vm.onHazardValid, change: _vm.onHazardChange }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showDetailSections,
              expression: "showDetailSections"
            }
          ],
          staticClass: "form-section"
        },
        [
          _c("div", { staticClass: "section-heading" }, [
            _vm._v(_vm._s(_vm.$t("legal")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section-body" },
            [
              _c("LegalAgreement", {
                ref: "legal",
                attrs: {
                  value: _vm.hasSignature,
                  "store-id": _vm.form.store_id,
                  stores: _vm.stores
                },
                on: {
                  signature: _vm.onSignature,
                  clear: _vm.onSignatureClear,
                  "terms-change": _vm.onTermsChange
                }
              }),
              _vm._v(" "),
              _vm.existingSignatureUrl && !_vm.signatureData
                ? _c("div", { staticClass: "existing-signature" }, [
                    _c("div", { staticClass: "existing-signature-label" }, [
                      _vm._v("Current signature on file:")
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: "/photo/" + _vm.existingSignatureUrl,
                        alt: "Existing signature"
                      }
                    })
                  ])
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "msg-fade" } }, [
        _vm.submitError
          ? _c("div", { staticClass: "error-banner" }, [
              _vm._v(_vm._s(_vm.submitError))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-submit",
          attrs: { type: "button", disabled: !_vm.canSubmit },
          on: { click: _vm.submit }
        },
        [
          _vm.submitting ? _c("span", { staticClass: "spinner" }) : _vm._e(),
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.submitting ? _vm.$t("submitting") : _vm.submitButtonLabel
              ) +
              "\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "field-label" }, [
      _vm._v("Email "),
      _c("span", { staticClass: "req" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b196786", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b196786","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingForm.vue
// module id = 438
// module chunks = 0